import {AcaoEixo} from "./acao-eixo";
import {Conta} from "./conta";
import {Convenente} from "./convenente";
import {Arquivo} from "./arquivo";
import {Forca} from "./forca";
import {NaturezaDespesa} from "./natureza-despesa";

export class Item {

    id: number =  0;
    nome: string =  "";
    acaoEixo?: AcaoEixo = new AcaoEixo();
    arquivos: Arquivo[] = new Array<Arquivo>();
    arquivosFinanceiros: Arquivo[] = new Array<Arquivo>();
    conta: Conta = new Conta();
    convenente: Convenente = new Convenente();
    dataExecucao: Date | null = null;
    forca: Forca = new Forca();
    idExecutor: number =  0;
    numeroEdoc: string =  "";
    numeroEmpenho: string =  "";
    numeroNotaFiscal: string =  "";
    isAtivo: boolean = true;
    isExecutado: boolean = true;
    naturezaDespesa: NaturezaDespesa = new NaturezaDespesa();
    quantidade?: number = undefined;
    valorCotado?: number = undefined;
    valorExecutado?: number = undefined;
    valorTotalExecutado: number =  0;

//Campos do DTO
    idAcao: number =  0;
    idForca: number =  0;
    idMeta: number =  0;
    idConta: number =  0;
    idConvenente: number =  0;


}